/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { visitRegisterNavigation } from './visit-register';
import { visitRegisterConfigNavigation } from './visit-register-config';

export const defaultNavigation: FuseNavigationItem[] = [
  {
    id: 'dashboard',
    title: 'Inicio',
    type: 'basic',
    icon: 'heroicons_solid:home',
    link: '/dashboard/home',
  },
  { ...visitRegisterNavigation},
  //{ ...visitRegisterConfigNavigation},
];
